<template>
  <div class="preview-wrap">
    <!-- header -->
    <div class="phone-header">
      <!-- 状态栏 -->
      <div class="phone-header-state">
        <span>
          {{ time }}
        </span>
        <span>
          <img class="state-img" src="./img/signal.png" alt="定位" />
          <img class="state-img" src="./img/wifi1.png" alt="定位" />
          <img class="state-img" src="./img/battery.png" alt="定位" />
        </span>
      </div>
      <!-- 标题栏 -->
      <div class="preview-title">
        <span><i class="el-icon-arrow-left"></i></span>
        <span>{{ $t('1021') }}</span>
        <span><i class="el-icon-refresh"></i></span>
      </div>
    </div>
    <!-- body -->
    <div class="preview-body">
      <div v-if="title" class="preview-body-title">
        <p>{{ title }}</p>
      </div>
      <ul class="preview-body-content">
        <slot></slot>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ' '
    }
  },
  data() {
    return {
      time: ''
    }
  },
  created() {
    this.timeUpdate()
  },
  methods: {
    timeUpdate() {
      setInterval(() => {
        this.time = this.$util.parseTime(new Date(), '{h}:{i}')
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
.preview-wrap {
  width: 362px;
  height: 669px;
  min-height: 669px;
  background: #ffffff;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.18);
  border-radius: 40px;
  margin: 36px auto;
  padding: 12px;
  padding-bottom: 30px;
  box-sizing: border-box;
  overflow: hidden;
  &-top {
    height: 35px;
    padding: 0 20px;
    box-sizing: border-box;
    border-top-left-radius: 40px;
    border-top-right-radius: 40px;
    background: #5D51DA;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .state-img {
      width: 14px;
      vertical-align: middle;
    }
  }
  .phone-header {
    height: 72px;
    box-sizing: border-box;
    border-top-left-radius: 40px;
    border-top-right-radius: 40px;
    background: $theme;
    color: #fff;
    &-state {
      height: 35px;
      box-sizing: border-box;
      padding: 0 24px 0 28px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: space-between;
      img {
        width: 15px;
        margin-left: 6px;
      }
    }
    .preview-title {
      padding: 0 20px;
      font-size: 18px;
      font-weight: 500;
      display: flex;
      justify-content: space-between;
      &-text {
        text-align: center;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
  .preview-body {
    padding: 11px 0px 36px;
    height: calc(100% - 72px);
    border: 1px solid #d9d9d9;
    border-bottom-left-radius: 40px;
    border-bottom-right-radius: 40px;
    box-sizing: border-box;
    background: #f7f8f9;
    overflow: hidden;
    &-title {
      max-height: 64px;
      background: #fff;
      padding: 12px 16px;
      box-sizing: border-box;
      font-weight: 500;
      font-size: 14px;
      color: #262626;
      p {
        height: 100%;
        width: 100%;
        line-height: 22px;
        white-space: break-spaces;
        word-break: break-word;
        overflow: hidden;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
    &-content {
      height: 100%;
      overflow: auto;
      padding-bottom: 40px;
    }
  }
}
.title-wrap {
  display: flex;
}
</style>
>
